import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
function useBulkUpdateFieldConfigs() {
  return useMutation(function (_ref) {
    var workspaceId = _ref.workspaceId,
      updates = _ref.updates;
    var fields = Object.entries(updates || {}).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        fieldName = _ref3[0],
        update = _ref3[1];
      return _objectSpread({
        field_name: fieldName
      }, update);
    });
    return servicesUtils.patchService("/acr/fields/".concat(workspaceId, "/bulk/"), {
      fields: fields
    });
  });
}
export default useBulkUpdateFieldConfigs;